import React from "react"
import styled from "styled-components"
import { HeadingTwo } from "buoy-core"
import responsive from "../../common/responsive"
import { colors, constants } from "buoy-theme"
import Card from "../Card"
import Label from "../Label"
import Partner from "../Partner"
import { LazyResImage } from "../../common/responsive"

const EnterpriseSection = styled.section`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 110px 0 0 0;
  text-align: center;
  ${responsive(
    "padding",
    "110px 0 0",
    "110px 0 0",
    "64px 20px 0",
    "64px 20px 0"
  )};
`

const CardsContainer = styled.div`
  ${responsive(
    "width",
    "100%",
    "100%",
    "auto",
  )};
  ${responsive(
    "margin",
    "20px auto 58px auto",
    "20px auto 58px auto",
    "20px auto 0",
    "20px auto 0"
  )};
  position: relative;
`

const Cards = styled.div`
  z-index: 2;
  display: flex;
  position: relative;
  margin: 0 auto;
  ${responsive("flex-direction", "row", "row", "column", "column")};
  ${responsive("max-width", "950px", "950px", "none", "none")};
`

const Dots = styled.div`
  position: absolute;
  ${responsive("width", "56px", "56px", "11px", "11px")}
  ${responsive("right", "-63px", "-63px", "200px", "140px")}
  ${responsive("top", "50%", "50%", "103.5%", "101.5%")}
  ${responsive("height", "20px", "20px", "15%", "15%")}
  background-image: radial-gradient(${
    colors.neutralLight
  } 20%, transparent 16%);
  background-size: 11px 11px;
  ${responsive(
    "background-repeat",
    "repeat-x",
    "repeat-x",
    "repeat-y",
    "repeat-y"
  )}
`

const CardColumn = styled.div`
  position: relative;
  ${responsive("flex", "1", "1", "0 1 auto")} ${props =>
    responsive(
      "margin-bottom",
      "0",
      "0",
      props.right ? "78px" : "55px",
      props.right ? "78px" : "55px"
    )}

  &:first-child {
    ${responsive("margin-right", "35px", "35px", "0", "0")};
  }

  &:last-child {
    ${responsive("margin-left", "35px", "35px", "0", "0")};
  }
`

const Trust = styled.div`
  text-align: center;
  ${responsive("margin-bottom", "110px", "110px", "80px", "64px")};
`

const Brands = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`
const BrandImageWrapper = styled.div`
  margin: 15px 20px;
`

const Heading = styled(HeadingTwo)`
  ${responsive("margin","0 0 48px 0","0 0 48px 0","0 0 24px 0")};
`

const Enterprise = ({ headline, label, partners, cta, theme, products }) => (
  <EnterpriseSection id="solutions">
    <Label>Employers</Label>
    <Heading>{headline}</Heading>
    <CardsContainer>
      <Cards>
        {products.map((p, index) => {
          let product = p.node
          if (product.copy && product.detailList.length > 0) {
            return (
              <CardColumn right={!index} key={index}>
                <Card
                  right={!index}
                  title={product.title}
                  subtitle={product.subtitle}
                  copy={product.copy}
                  color={product.color}
                  boxShadow={constants.boxShadow}
                  buttonText="Request a demo"
                  image={product.image}
                  url={product.page_url}
                />
              </CardColumn>
            )
          }
        })}
      </Cards>
    </CardsContainer>

    <Trust>
      <Label>{label}</Label>
      <Brands>
        {partners.map((partner, index) => (
          <BrandImageWrapper key={index}>
            <LazyResImage src={partner.logo}>
              <img />
            </LazyResImage>
          </BrandImageWrapper>
        ))}
      </Brands>
    </Trust>

    <Partner {...cta} />
  </EnterpriseSection>
)

export { Enterprise as default }



// WEBPACK FOOTER //
// ./src/components/Enterprise/index.js